import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import {Container, Button, Box, Drawer, Hidden, ListItem, List, ListItemText} from '@material-ui/core';
import Logo from '../../assests/images/logo.svg'
import LiveLogo from '../../assests/images/ItsLive.png'
import CloseIcon from '@material-ui/icons/Close';
import {Link, useLocation, NavLink} from "react-router-dom";
import {JsonContext} from "../../Context";

const drawerWidth = 240;


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.down('sm')] : {
        position: 'relative',
        zIndex: '9999',
        paddingTop: '80px'
    },
    [theme.breakpoints.down('xs')] : {
        paddingTop: '72px'
    },
    paddingTop: '104px'
  },
  appBar: {
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up('md')] : {
        padding: '20px 72px'
    },
    [theme.breakpoints.down('sm')] : {
        padding: '8px 15px'
    }
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      flexShrink: 0,
    },
  },
  drawerPaper: {
    background: 'none'
  },
  menuButton: {
    padding: '0',
    margin: '0',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  menuItems: {
    fontFamily: 'Manrope',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.112673px',
    color: theme.palette.text.primary,
    textDecoration: 'none',
    paddingRight: '56px',
    opacity: '0.7',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
  },
  },
  title: {
    flexGrow: 1,
  },
  logoWrapper: {
    [theme.breakpoints.down('xs')]: {
        width: '100%',
        textAlign: 'center'
    },
  },
  box: {
      paddingLeft: '106px',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: '15px',
    },
  },
  logo: {
    [theme.breakpoints.down('sm')]: {
        maxWidth: '112px',
    },
  },
  liveLogo: {
    flexDirection: 'row-reverse'
  },
  iconBtn: {
    fill: theme.palette.fill.color,
  },
  listWrapper: {
    paddingTop: '48px',
  },
  listItem: {
    fontSize: '18px',
    lineHeight: '27.81px',
    display: 'block',
    textAlign: 'center',
    paddingBottom: '32px',
  },
  listLink: {
    color: theme.palette.text.primary,
    textDecoration: 'none'
  }
}));

const pages = ['HOME', 'LIVESTREAM SCHEDULE'];


function ResponsiveDrawer(props) {
  const { window } = props;
  const {location} = useLocation();
  const theme = useTheme();
  const classes = useStyles(theme);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [closeIconOpen, setcloseIconOpen] = React.useState(false);
  const [openIcon, setOpenIcon] = React.useState(true);
  const data = useContext(JsonContext).header;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
    setOpenIcon(!openIcon)
    setcloseIconOpen(!closeIconOpen)
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  // const handleNavItems = () => {
  //   return (
  //     pages && pages.map((item) => {
  //       <Link to={"/"} className={classes.menuItems}>
  //          {item}
  //       </Link>
  //     })
  //   )
  // }


  const container = window !== undefined ? () => window().document.body : undefined;

  console.log('location=============', location);


  return (
    <div className={classes.root}>
    <AppBar position="fixed" className={classes.appBar}>
      <Box>
        <Toolbar disableGutters>
            <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
            >
               {openIcon &&  <MenuIcon className={classes.iconBtn} />}
                {closeIconOpen && <CloseIcon className={classes.iconBtn} />}
            </IconButton>  
          <Typography
            variant="h6"
            noWrap
            component="div"
            className={classes.logoWrapper}
            sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
          >
            <Link to={"/"}><img src={data.logo || Logo} alt="Logo" className={classes.logo} /></Link>
          </Typography>

          <Box className={classes.box} sx={{ flexGrow: 1, display: { xs: 'none', sm: 'flex' } }}>
            {/* {pages.map((page) => (
              <Link
                className={classes.menuItems}
                key={page}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page}
              </Link>
            ))} */}
            <NavLink to={"/"} className={classes.menuItems} exact activeClassName="active">
              HOME
            </NavLink>
            <NavLink to={"/schedule"} className={classes.menuItems} activeClassName="active">
              LIVESTREAM SCHEDULE
            </NavLink>

          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', sm: 'flex' }, justifyContent: 'right'}} className={classes.liveLogo}>
              <img src={data.subLogo || LiveLogo} alt="Live Logo" />
          </Box>
        </Toolbar>
        <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css" className={classes.mobileIcon}>
         <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            style={{backgroundColor: theme.palette.drawer.default}}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <List className={classes.listWrapper}>
                {/* {pages.map((text, index) => (
                <ListItem button key={text}>
                    <ListItemText primary={text} />
                </ListItem>
                ))} */}
                <ListItem className={classes.listItem}  onClick={handleDrawerToggle}>
                <NavLink to="/" className={classes.listLink} exact activeClassName="active">
                  HOME
                </NavLink>
                </ListItem>
                <ListItem className={classes.listItem}  onClick={handleDrawerToggle}>
                <NavLink to="/schedule" className={classes.listLink} activeClassName="active">
                  LIVESTREAM SCHEDULE
                </NavLink>
                </ListItem>
            </List>
          </Drawer>
            </Hidden>
        </nav>

      </Box>
    </AppBar>
    </div>
  );
}

ResponsiveDrawer.propTypes = {
    window: PropTypes.func,
  };

export default ResponsiveDrawer;  